<template>
  <v-app>
    <transition mode="out-in">
      <router-view />
    </transition>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  components: {},
  mounted () {
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // FIXME:appでalignしているため対応が必要。すべて中央寄りになってしまう。
  // text-align: center;
  color: #2c3e50;
}
.youtube {
  width: 100%;
  aspect-ratio: 16 / 9;
}
.youtube iframe {
  width: 100%;
  height: 100%;
}

img {
  width: 100%;
  height: 100%;
}

.qimg{
  max-width: 100%;
  width: auto;
}

.qimg_small{
  max-height:300px;
  max-width: 100%;
  width: auto;
}

.qcimg{
  max-height: 80px;
  max-width: 100%;
  width: auto;
}

.qcimg_middle{
  max-height: 160px;
  max-width: 100%;
  width: auto;
}
.qcimg_large{
  max-height: 240px;
  max-width: 100%;
  width: auto;
}

#question {
  text-align: initial;
}
</style>
